import React, { useState } from 'react';
import { Card, Row, Col, Button, Table, Pagination } from 'react-bootstrap';
import { useQuery } from 'react-query';
import { LICHHOCTHUCHANH_API } from '../../../utils/apiUrl';
import { Get } from '../../../utils/httpProvider';
import { toast } from 'react-toastify';

const StudentTimelineView = ({ contractId, selectedStudentId }) => {
    const [currentPage, setCurrentPage] = useState(1);
    const pageSize = 10;

    React.useEffect(() => {
        setCurrentPage(1);
    }, [selectedStudentId]);

    // Fetch timeline data
    const { data, isLoading, error } = useQuery(
        ['studentTimeline', contractId, selectedStudentId],
        () => {
            let url = LICHHOCTHUCHANH_API.GET_STUDENT_TIMELINE;
            const params = [];
            if (contractId) {
                params.push(`hopDongChiTietId=${contractId}`);
            }
            if (selectedStudentId) {
                params.push(`studentAccountId=${selectedStudentId}`);
            }
            if (params.length > 0) {
                url += `?${params.join('&')}`;
            }
            return Get(url).then(res => res?.data || res);
        },
        {
            enabled: !!contractId && !!selectedStudentId
        }
    );

    const handleDownloadIcs = () => {
        const dots = data?.dots || [];
        if (dots.length === 0) {
            toast.info("Không có lịch học để xuất.");
            return;
        }

        let icsContent = "BEGIN:VCALENDAR\nVERSION:2.0\nPRODID:-//HLDT//NONSGML Luan Chuyen Lam Sang//EN\n";
        dots.forEach((dot, index) => {
            const startMatch = (dot.ngayBatDauStr || '').split('/');
            const endMatch = (dot.ngayKetThucStr || '').split('/');
            if (startMatch.length === 3 && endMatch.length === 3) {
                const startFormatted = `${startMatch[2]}${startMatch[1]}${startMatch[0]}`;
                const endFormatted = `${endMatch[2]}${endMatch[1]}${endMatch[0]}`;
                icsContent += `BEGIN:VEVENT\n`;
                icsContent += `UID:event-${index}-${Date.now()}@hldt.vn\n`;
                icsContent += `DTSTART;VALUE=DATE:${startFormatted}\n`;
                icsContent += `DTEND;VALUE=DATE:${endFormatted}\n`;
                icsContent += `SUMMARY:Học lâm sàng: ${dot.donViTen || 'Khoa đào tạo'}\n`;
                icsContent += `DESCRIPTION:Giảng viên hướng dẫn: ${dot.giangVienTen || 'Chưa phân công'}\\nNội dung: ${dot.trinhDo || ''}\n`;
                icsContent += `END:VEVENT\n`;
            }
        });
        icsContent += "END:VCALENDAR";

        const blob = new Blob([icsContent], { type: 'text/calendar;charset=utf-8' });
        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.setAttribute('download', `lich_trinh_lam_sang_${selectedStudentId}.ics`);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        toast.success("Đã tải lịch .ics thành công!");
    };

    const hasDots = data?.dots && data.dots.length > 0;

    return (
        <div className="p-1">
            <style>{`
                .clinical-header-card {
                    border-radius: 12px;
                    box-shadow: 0 1px 3px rgba(0,0,0,0.05);
                    border: 1px solid #e2e8f0;
                }
                .clinical-table {
                    background: #ffffff;
                    border: 1px solid #cbd5e1;
                    border-radius: 8px;
                    overflow: hidden;
                }
                .clinical-table th {
                    background: #f1f5f9;
                    color: #1e293b;
                    font-weight: 700;
                    border-bottom: 2px solid #cbd5e1;
                    font-size: 0.85rem;
                    text-transform: uppercase;
                    padding: 10px 12px;
                }
                .clinical-table td {
                    padding: 10px 12px;
                    vertical-align: middle;
                    font-size: 0.85rem;
                    border-bottom: 1px solid #e2e8f0;
                    color: #334155;
                }
                .clinical-table tbody tr.active-row td {
                    background-color: #eff6ff;
                    font-weight: 500;
                }
                .clinical-badge {
                    font-size: 0.75rem;
                    padding: 4px 8px;
                    border-radius: 4px;
                    font-weight: 600;
                    display: inline-block;
                }
                .clinical-badge-running {
                    background-color: #2563eb;
                    color: #ffffff;
                }
                .clinical-badge-completed {
                    background-color: #64748b;
                    color: #ffffff;
                }
                .clinical-badge-upcoming {
                    background-color: #e2e8f0;
                    color: #475569;
                    border: 1px solid #cbd5e1;
                }
                .clinical-week-tag {
                    font-size: 0.75rem;
                    padding: 4px 8px;
                    border-radius: 6px;
                    font-weight: 600;
                }
                .clinical-week-tag.active {
                    color: var(--primary);
                    background: rgba(0, 123, 255, 0.1);
                    border: 1px solid rgba(0, 123, 255, 0.2);
                }
                .clinical-week-tag.done {
                    text-decoration: line-through;
                    color: #94a3b8;
                    background: #f1f5f9;
                }
            `}</style>

            {isLoading ? (
                <div className="text-center py-5">
                    <div className="spinner-border text-primary spinner-border-sm mr-2" role="status"></div>
                    <span className="text-muted font-weight-bold">Đang tải lịch học viên...</span>
                </div>
            ) : error ? (
                <div className="alert alert-danger m-0">
                    Lỗi tải lịch học lâm sàng học viên.
                </div>
            ) : !data ? (
                <Card className="text-center py-4 border-light bg-light">
                    <Card.Body className="text-muted">Chọn học viên để hiển thị bảng lộ trình luân chuyển.</Card.Body>
                </Card>
            ) : (
                <div>
                    {/* Thông tin học viên */}
                    <Card className="clinical-header-card p-3 mb-3 border-light">
                        <Row className="align-items-center">
                            <Col md={8}>
                                <div className="text-muted small font-weight-bold">BSNT LUÂN CHUYỂN LÂM SÀNG</div>
                                <h4 className="font-weight-bold text-dark mb-1 mt-1">{data?.hocVienTen || 'Học viên'}</h4>
                                <div className="text-muted small">
                                    Chuyên ngành: <strong>{data?.chuyenNganh || 'Chuyên ngành'}</strong> &middot; Trình độ: <strong>{data?.trinhDo || 'Năm học'}</strong>
                                </div>
                            </Col>
                            <Col md={4} className="text-md-right mt-2 mt-md-0">
                                <Button 
                                    variant="outline-primary" 
                                    size="sm" 
                                    style={{ borderRadius: '6px', fontWeight: 'bold' }}
                                    onClick={handleDownloadIcs}
                                >
                                    <i className="fas fa-file-download mr-1"></i> Tải file lịch (.ics)
                                </Button>
                            </Col>
                        </Row>
                    </Card>

                    {/* Bảng lộ trình lâm sàng */}
                    <h5 className="font-weight-bold text-dark mb-2 mt-3">
                        <i className="fas fa-table mr-2 text-primary"></i> Bảng lộ trình thực hành lâm sàng chi tiết
                    </h5>

                    {(!hasDots) ? (
                        <Card className="text-center py-4 border-light bg-light">
                            <Card.Body className="text-muted">Không có dữ liệu phân bổ lịch đào tạo lâm sàng.</Card.Body>
                        </Card>
                    ) : (
                        <>
                            <div className="clinical-table table-responsive">
                                <Table className="mb-0 text-left">
                                    <thead>
                                        <tr>
                                            <th style={{ width: '50px', textAlign: 'center' }}>STT</th>
                                            <th>Nội dung / Chuyên khoa thực hành</th>
                                            <th>Khoa / Phòng lâm sàng</th>
                                            <th>Giảng viên hướng dẫn</th>
                                            <th style={{ width: '180px' }}>Thời gian thực hành</th>
                                            <th>Kế hoạch tuần</th>
                                            <th>Nghỉ phép</th>
                                            <th style={{ width: '150px', textAlign: 'center' }}>Trạng thái</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {(() => {
                                            const dotsList = data?.dots || [];
                                            const paginatedDots = dotsList.slice((currentPage - 1) * pageSize, currentPage * pageSize);
                                            return paginatedDots.map((dot, index) => {
                                                const isRunning = dot.statusDisplay === 'running';
                                                
                                                return (
                                                    <tr key={dot.id || index} className={isRunning ? 'active-row' : ''}>
                                                        <td style={{ textAlign: 'center' }} className="font-weight-bold">{(currentPage - 1) * pageSize + index + 1}</td>
                                                        <td className="font-weight-bold text-dark">{dot.chuyenNganh}</td>
                                                        <td>{dot.khoa}</td>
                                                        <td>{dot.gvls}</td>
                                                        <td className="font-weight-bold">{dot.ngayBatDauStr} - {dot.ngayKetThucStr}</td>
                                                        <td>
                                                            {dot.activeWeekInfo && dot.activeWeekInfo.split(' &middot; ').map((w, wIdx) => {
                                                                const isActive = w.includes('(đang)');
                                                                const isWDone = w.includes('✓');
                                                                const cleanLabel = w.replace(' (đang)', '').replace(' ✓', '');
                                                                return (
                                                                    <span key={wIdx} className={`clinical-week-tag ${isActive ? 'active' : isWDone ? 'done' : ''}`}>
                                                                        {cleanLabel}
                                                                    </span>
                                                                );
                                                            })}
                                                        </td>
                                                        <td className="text-danger font-weight-bold">{dot.ngayNghiTheoLichStr || '-'}</td>
                                                        <td style={{ textAlign: 'center' }}>
                                                            {isRunning ? (
                                                                 <span className="clinical-badge clinical-badge-running">Đang học</span>
                                                            ) : dot.statusDisplay === 'completed' ? (
                                                                 <span className="clinical-badge clinical-badge-completed">Đã hoàn thành</span>
                                                            ) : (
                                                                 <span className="clinical-badge clinical-badge-upcoming">Sắp tới</span>
                                                            )}
                                                        </td>
                                                    </tr>
                                                );
                                            });
                                        })()}
                                    </tbody>
                                </Table>
                            </div>
                            {(() => {
                            const dotsList = data?.dots || [];
                            const totalPages = Math.ceil(dotsList.length / pageSize);
                            return (
                                <div className="d-flex justify-content-between align-items-center mt-3 px-1">
                                    <div className="text-muted small">
                                        Hiển thị {dotsList.length > 0 ? (currentPage - 1) * pageSize + 1 : 0} - {Math.min(dotsList.length, currentPage * pageSize)} trong tổng số {dotsList.length} dòng
                                    </div>
                                    {totalPages > 1 && (
                                        <Pagination size="sm" className="mb-0" style={{ borderRadius: '6px' }}>
                                            <Pagination.First onClick={() => setCurrentPage(1)} disabled={currentPage === 1} />
                                            <Pagination.Prev onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))} disabled={currentPage === 1} />
                                            {Array.from({ length: Math.min(5, totalPages) }, (_, i) => {
                                                let pageNum;
                                                if (totalPages <= 5) {
                                                    pageNum = i + 1;
                                                } else {
                                                    pageNum = currentPage - 2 + i;
                                                    if (currentPage <= 2) pageNum = i + 1;
                                                    if (currentPage >= totalPages - 1) pageNum = totalPages - 4 + i;
                                                }
                                                if (pageNum < 1) pageNum = 1;
                                                if (pageNum > totalPages) return null;
                                                return (
                                                    <Pagination.Item
                                                        key={pageNum}
                                                        active={pageNum === currentPage}
                                                        onClick={() => setCurrentPage(pageNum)}
                                                    >
                                                        {pageNum}
                                                    </Pagination.Item>
                                                );
                                            })}
                                            <Pagination.Next onClick={() => setCurrentPage(prev => Math.min(prev + 1, totalPages))} disabled={currentPage === totalPages} />
                                            <Pagination.Last onClick={() => setCurrentPage(totalPages)} disabled={currentPage === totalPages} />
                                        </Pagination>
                                    )}
                                </div>
                            );
                        })()}
                        </>
                    )}
                </div>
            )}
        </div>
    );
};

export default StudentTimelineView;
